export const lcut = require('@node-rs/jieba').cut
export default () => {}